<mat-form-field appearance="outline">
  <mat-label>{{'ADMIN.SELECT_CULTURE' | translate}}</mat-label>
  <mat-select [(ngModel)]="selectedCulture" (selectionChange)="changeCulture()">
    <mat-option *ngFor="let culture of authService.cultures" [value]="culture">
      {{culture.name}}
    </mat-option>
  </mat-select>
</mat-form-field>